import React from 'react';
import { Grid, Input, Button, Form, TextArea } from 'semantic-ui-react';
import Server from '../../../functions/server'
import $ from "jquery";
import Loading from '../../loading';

class Title extends React.Component {

state = {
  state: 'Tamil Nadu',
  data: this.props.data,
  load: false,
  message: '',
  code: ''
}

onChange = (type) => (e, {value}) => {
  this.setState({
    [type]: value,
    error: ''
  })
}

onChange1 = (type) => (e, {value}) => {
  value = value.toUpperCase();
  if(false) {

  }
  else {
    if (value.length == 2) {
      let context = this;
      $.ajax({
        type: 'POST',
        data: { 'code': value },
        url: Server() + 'branchdetails/checkcode.php',
        success: function(data)
        {
          let check = 0;
          try {
            data = JSON.parse(data);
            data.map((x) => {
              check = x.checks;
            })
            if (check != 0) {
              if (check == 'true') {
                alert("Branch Code is Already Taken!!!!")
              }
              else {
                context.setState({ code: value })
              }
            }
          } catch (e) {
            console.log("try Again");;
          }
        },
        error: function(e)
        {
          alert('Try again!!')
          context.setState({
            load: false
          });
        }
      });
    }
    else {
      this.setState({ code: value })
    }
  }
}

cancel() {
  this.props.handleClose();
}

update() {
  let context = this;
  let name= this.state.name;
  let taluk = this.state.taluk;
  let district = this.state.district;
  let address = this.state.address;
  let state = this.state.state;
  let phone = this.state.phone;
  let pincode = this.state.pincode;
  let gstin = this.state.gstin;
  let code = this.state.code;
  if (pincode == '' || pincode == null || pincode == undefined) {
    this.setState({error: 'Enter the pincode' }); return;
  }
  if (code == '' || code == null || code == undefined) {
    this.setState({error: 'Enter the code' }); return;
  }
  if (name == '' || name == null || name == undefined) {
    this.setState({error: 'Enter the Branch name' }); return;
  }
  if (phone == '' || phone == null || phone == undefined) {
    this.setState({error: 'Enter the phone number' }); return;
  }
  if (taluk == '' || taluk == null || taluk == undefined) {
    this.setState({ error: 'Enter the Taluk' }); return;
  }
  if (district == '' || district == null || district == undefined) {
    this.setState({ error: 'Enter the District' }); return;
  }
  if (address == '' || address == null || address == undefined) {
    this.setState({ error: 'Enter the Address' }); return;
  }
  if (state == '' || state == null || state == undefined) {
    this.setState({ error: 'Enter the State' }); return;
  }
  let data1 = { 'name': name, 'address': address, 'taluk': taluk,
                'district': district, 'state': state, 'phone': phone,
                'pincode': pincode, 'gstin': gstin, 'code': code };
   context.setState({
     load: true,
     message: 'Add Branch Details'
   });
  $.ajax({
    type: 'POST',
    data: data1,
    url: Server() + 'branchdetails/add.php',
    success: function(data)
    {
      context.setState({
        load: false,
      });
      if (data == 1) {
        context.props.updateDatas();
      }
      else {
        alert('Error!!!')
      }
    },
    error: function(e)
    {
      alert('Try again!!')
      context.setState({
        load: false
      });
    }
  });
}


render() {
  return (
    <div>
    <Loading load={this.state.load} message={this.state.message} />
      <Grid>
        <Grid.Column mobile={16} tablet={16} computer={13}>
        Branch Name<br/>
        <Input fluid focus onChange={this.onChange('name')}
          placeholder='Branch Name' value={this.state.name} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={3}>
        CODE<br/>
        <Input fluid focus onChange={this.onChange1('code')}
          placeholder='CODE' value={this.state.code} />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={16}>
        Address<br/>
        <Form>
          <TextArea placeholder='address' onChange={this.onChange('address')} />
        </Form>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Taluk<br/>
        <Input fluid focus
          onChange={this.onChange('taluk')}
          placeholder='Branch Name' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        District<br/>
        <Input fluid focus
          onChange={this.onChange('district')}
          placeholder='District' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        Phone<br/>
        <Input fluid focus
          onChange={this.onChange('phone')}
          placeholder='Phone' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        State<br/>
        <Input fluid focus
          onChange={this.onChange('state')}
          placeholder='state' value={this.state.state} />
        </Grid.Column>

        <Grid.Column mobile={16} tablet={16} computer={8}>
        Pincode<br/>
        <Input fluid focus
          onChange={this.onChange('pincode')}
          placeholder='Pincode' />
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
        GSTIN<br/>
        <Input fluid focus
          onChange={this.onChange('gstin')}
          placeholder='gstin' value={this.state.gstin} />
        </Grid.Column>


        <Grid.Column mobile={16} tablet={16} computer={16}>
          <center style={{color: 'red'}}>{this.state.error}</center>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.cancel.bind(this)}>Cancel</Button>
        </Grid.Column>
        <Grid.Column mobile={16} tablet={16} computer={8}>
          <Button fluid onClick={this.update.bind(this)}>Save</Button>
        </Grid.Column>
      </Grid>
    </div>
  );
}
}

export default Title;
